export default [

     {
          path: '/course',
          name: 'Course',
          component: () => import("@/views/Page/Course/Course.vue"),
           meta: {
               title: 'Courses Management',
          },
     },
     {
          path: '/course/statistics',
          name: 'CourseStatistics',
          component: () => import("@/views/Page/Course/CourseStatistics.vue"),
           meta: {
               title: 'Course Statistics',
          },
     }
];